/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here. (Focal theme doc comment retained below.)
 */

/* =====================================================================
   LAWNHUB - PDP enhancements (product-story ".tj" section)
   Calculator: one best-match option; hide nonsensical "One application";
   duration-only option line; free-calendar list item. ASCII only, no
   regex backslashes (the connector mangles them). No-ops without .tj.
   ===================================================================== */
(function () {
  'use strict';

  function toNum(s) { return parseFloat(String(s || '').replace(/[^0-9.]/g, '')) || 0; }

  function filterCalc(root) {
    var wrap = root.querySelector('.tj-calc__value');
    if (!wrap) return;
    var opts = [].slice.call(wrap.querySelectorAll('.tj-calc__opt'));
    if (opts.length < 2) { opts.forEach(function (o) { o.style.display = ''; }); return; }
    var parsed = opts.map(function (el) {
      return {
        el: el,
        price: toNum((el.querySelector('.tj-calc__opt-r b') || {}).textContent),
        isBest: (((el.querySelector('.tj-calc__opt-l i') || {}).textContent) || '').toLowerCase().indexOf('best match') > -1
      };
    });
    var best = parsed.filter(function (p) { return p.isBest; })[0];
    if (!best) { best = parsed.slice().sort(function (a, b) { return a.price - b.price; })[0]; }
    parsed.forEach(function (p) { p.el.style.display = (p === best) ? '' : 'none'; });
  }

  function tunePeriods(root) {
    var wrap = root.querySelector('.tj-calc__period');
    if (!wrap) return;
    var btns = [].slice.call(wrap.querySelectorAll('button'));
    var oneBtn = btns.filter(function (b) { return b.textContent.toLowerCase().indexOf('one application') > -1; })[0];
    if (!oneBtn || !oneBtn.classList.contains('on')) return;
    var firstOpt = root.querySelector('.tj-calc__value .tj-calc__opt');
    if (!firstOpt) return;
    var durTxt = ((firstOpt.querySelector('.tj-calc__opt-r small') || {}).textContent) || '';
    var m = durTxt.match(/([0-9]+) application/);
    var apps = m ? parseInt(m[1], 10) : 1;
    if (apps >= 2) {
      oneBtn.style.display = 'none';
      var six = btns.filter(function (b) { return b.textContent.toLowerCase().indexOf('6 month') > -1; })[0];
      if (six) six.click();
    }
  }

  function tidyDuration(root) {
    var approx = String.fromCharCode(8776);
    [].slice.call(root.querySelectorAll('.tj-calc__value .tj-calc__opt .tj-calc__opt-r small')).forEach(function (s) {
      var txt = s.textContent || '';
      var i = txt.indexOf(approx);
      if (i > -1) { var dur = txt.slice(i + 1).trim(); if (dur) s.textContent = 'Lasts ' + dur; }
    });
  }

  function addCalendarNote(root) {
    var list = root.querySelector('.tj-packlist');
    if (!list || list.querySelector('.tj-packcal')) return;
    var cals = [].slice.call(root.querySelectorAll('.tj-docbtn')).filter(function (d) {
      var h = (d.getAttribute('href') || '').toLowerCase();
      var t = (d.textContent || '').toLowerCase();
      return h.indexOf('calendar') > -1 || t.indexOf('calendar') > -1;
    });
    if (!cals.length) return;
    cals.forEach(function (cal) {
      var href = cal.getAttribute('href') || '#';
      var name = ((((cal.querySelector('b') || {}).textContent) || cal.textContent || 'Calendar').split('PDF')[0]).trim() || 'Calendar';
      var li = document.createElement('li');
      li.className = 'tj-packcal';
      li.innerHTML = 'A free <a href="' + href + '" target="_blank" rel="noopener">' + name + ' (PDF)</a> &mdash; what to apply, when';
      list.appendChild(li);
    });
  }

  function injectCss() {
    if (document.getElementById('tj-packcal-css')) return;
    var st = document.createElement('style');
    st.id = 'tj-packcal-css';
    st.textContent = '.tj-packcal a{color:#4b7d1f;font-weight:700;text-decoration:underline}';
    document.head.appendChild(st);
  }

  function run(root) {
    try { filterCalc(root); } catch (e) {}
    try { tunePeriods(root); } catch (e) {}
    try { tidyDuration(root); } catch (e) {}
    try { addCalendarNote(root); } catch (e) {}
  }

  function init() {
    var root = document.querySelector('.tj');
    if (!root) return;
    injectCss();
    run(root);
    var target = root.querySelector('.tj-calcwrap') || root;
    var t;
    var obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { run(root); }, 60); });
    obs.observe(target, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function () { run(root); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - "The Test" results framing (Clint, 17 Jul). ASCII only.
   ===================================================================== */
(function () {
  'use strict';
  function clean(s) { return String(s || '').replace(/[^A-Za-z0-9 .'-]/g, '').trim().slice(0, 24); }
  function init() {
    var path = location.pathname.toLowerCase();
    if (path.indexOf('/collections/results-') === -1) return;
    var name = '';
    try {
      var q = new URLSearchParams(location.search);
      name = clean(q.get('name') || q.get('first_name') || '');
      if (name) sessionStorage.setItem('lhTestName', name);
      else name = clean(sessionStorage.getItem('lhTestName') || '');
    } catch (e) {}
    var h1 = document.querySelector('h1');
    if (!h1) return;
    if (h1.textContent.toLowerCase().indexOf('result') === -1) return;
    h1.textContent = name ? (name + "'s results") : 'Your personalised results';
    if (!document.getElementById('lh-test-frame')) {
      var wrap = document.createElement('div');
      wrap.id = 'lh-test-frame';
      wrap.innerHTML =
        '<p class="lh-test-frame__sub">Based on your answers in The Test, this is the gear we would put on your lawn.</p>' +
        '<a class="lh-test-frame__btn" href="/pages/quiz">&#8592; Retake The Test</a>';
      h1.insertAdjacentElement('afterend', wrap);
      var st = document.createElement('style');
      st.textContent =
        '#lh-test-frame{text-align:center;margin:6px 0 10px}' +
        '#lh-test-frame .lh-test-frame__sub{font-size:15px;line-height:1.5;color:#5b5f56;margin:0 0 12px}' +
        '#lh-test-frame .lh-test-frame__btn{display:inline-flex;align-items:center;gap:6px;min-height:40px;padding:9px 18px;border-radius:99px;background:#77C043;color:#16210B;font-weight:800;font-size:14px;text-decoration:none}';
      document.head.appendChild(st);
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Copy polish pass (Clint round 2, 21 Jul). m2 -> superscript,
   10mm wording, Small->Mini College, SDS link buttons. ASCII only.
   ===================================================================== */
(function () {
  'use strict';
  var SUP2 = String.fromCharCode(178);
  var M2RE = /([0-9])m2/gi;
  var SWAPS = [
    ['watered in with 10mm+.', 'watered in with 10mm of irrigation or equivalent rainfall.'],
    ['Small College Party Pack', 'Mini College Party Pack'],
    ['turfgrass', 'lawn'],
    [' turf ', ' lawn '],
    [' turf.', ' lawn.'],
    [' turf,', ' lawn,'],
    ['Turf ', 'Lawn '],
    ['established turf', 'established lawn']
  ];
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };
  function fixText() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var p = node.parentNode;
      if (!p || SKIP[p.nodeName]) continue;
      var t = node.nodeValue;
      if (!t || t.length < 3) continue;
      var out = t;
      if (M2RE.test(out)) { M2RE.lastIndex = 0; out = out.replace(M2RE, '$1m' + SUP2); }
      for (var i = 0; i < SWAPS.length; i++) { if (out.indexOf(SWAPS[i][0]) > -1) out = out.split(SWAPS[i][0]).join(SWAPS[i][1]); }
      if (out !== t) node.nodeValue = out;
    }
  }
  function tagSdsLinks() {
    [].slice.call(document.querySelectorAll('a')).forEach(function (a) {
      if (a.classList.contains('tj-docbtn') || a.classList.contains('tj-sdslink')) return;
      var t = (a.textContent || '').trim();
      var h = (a.getAttribute('href') || '');
      if (t.length < 4 || t.length > 60) return;
      var up = t.toUpperCase();
      if (up.indexOf('SDS') === -1 && up.indexOf('LABEL') === -1) return;
      if (h.indexOf('.pdf') === -1 && h.indexOf('cdn.shopify.com') === -1) return;
      a.classList.add('tj-sdslink');
      if (!a.getAttribute('target')) { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener'); }
    });
  }
  function injectCss() {
    if (document.getElementById('lh-copy-polish-css')) return;
    var st = document.createElement('style');
    st.id = 'lh-copy-polish-css';
    st.textContent =
      'a.tj-sdslink{display:inline-flex;align-items:center;gap:8px;background:#fff5ec;border:2px solid #F7941D;color:#B5540A !important;font-weight:800;font-size:14px;border-radius:12px;padding:10px 16px;margin:4px 8px 4px 0;text-decoration:none !important;transition:border-color .15s ease,background .15s ease}' +
      'a.tj-sdslink:hover{border-color:#d97e12;background:#ffe9d3}' +
      'a.tj-sdslink span{color:inherit !important}';
    document.head.appendChild(st);
  }
  var t;
  function run() { clearTimeout(t); t = setTimeout(function () { try { fixText(); tagSdsLinks(); } catch (e) {} }, 120); }
  function init() {
    injectCss();
    run();
    ['cart:updated', 'cart:refresh', 'variant:changed'].forEach(function (ev) {
      document.addEventListener(ev, run);
      document.documentElement.addEventListener(ev, run);
    });
    var tj = document.querySelector('.tj');
    if (tj) new MutationObserver(run).observe(tj, { childList: true, subtree: true });
    var mc = document.getElementById('mini-cart');
    if (mc) new MutationObserver(run).observe(mc, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Complementary cart recommendations (Clint round 2, 21 Jul;
   fallback fix 22 Jul). Cart drawer fetches Shopify recommendations with
   no intent (default related -> similar packs). This shim requests
   intent=complementary and uses it ONLY IF it returns real product cards
   (parsed .product-item count > 0). If complementary is not yet curated
   in Search & Discovery it returns an empty section (which still contains
   the string "product-item" in a template, so we must COUNT elements, not
   substring-match) and we fall back to the original related results.
   Editing theme.js is off-limits (huge core file). ASCII only.
   ===================================================================== */
(function () {
  'use strict';
  if (!window.fetch) return;
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = '';
    try { url = (typeof input === 'string') ? input : ((input && input.url) || ''); } catch (e) {}
    var isCartRecs = url.indexOf('recommendations/products') > -1 && url.indexOf('mini-cart') > -1 && url.indexOf('intent=') === -1;
    if (!isCartRecs) return origFetch(input, init);
    var compUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'intent=complementary';
    return origFetch(compUrl, init).then(function (res) {
      if (!res.ok) return origFetch(url, init);
      return res.clone().text().then(function (body) {
        var cards = 0;
        try { cards = new DOMParser().parseFromString(body, 'text/html').querySelectorAll('.product-item').length; } catch (e) {}
        if (cards > 0) {
          return new Response(body, { status: res.status, statusText: res.statusText, headers: { 'Content-Type': res.headers.get('Content-Type') || 'text/html' } });
        }
        return origFetch(url, init);
      });
    }).catch(function () { return origFetch(url, init); });
  };
})();

/* =====================================================================
   LAWNHUB - Photo detection for the PDP gallery (22 Jul). PNG photos
   (opaque corners) fill the frame; transparent cut-outs stay framed.
   ASCII only.
   ===================================================================== */
(function () {
  'use strict';
  function cornersOpaque(img) {
    try {
      var c = document.createElement('canvas');
      c.width = 8; c.height = 8;
      var x = c.getContext('2d');
      x.drawImage(img, 0, 0, 8, 8);
      var d = x.getImageData(0, 0, 8, 8).data;
      var corners = [0, 7, 56, 63];
      for (var i = 0; i < corners.length; i++) { if (d[corners[i] * 4 + 3] < 250) return false; }
      return true;
    } catch (e) { return false; }
  }
  function check(img) {
    if (!img || img.classList.contains('tj-fill')) return;
    var src = img.currentSrc || img.src || '';
    if (!src) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () { if (cornersOpaque(probe)) img.classList.add('tj-fill'); };
    probe.src = src;
  }
  function init() {
    var main = document.querySelector('.tj-gal__main');
    if (!main) return;
    var run = function () { setTimeout(function () { check(main); }, 60); };
    if (main.complete) run();
    main.addEventListener('load', run);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Non-lawn product cleanup (22 Jul). Hide lawn seasons + lawn
   type chips on the HAND JOB hand-cleaner page. ASCII only.
   ===================================================================== */
(function () {
  'use strict';
  var NON_LAWN = ['/products/lawnhub-hand-job'];
  var path = location.pathname.toLowerCase();
  var hit = false;
  for (var i = 0; i < NON_LAWN.length; i++) { if (path.indexOf(NON_LAWN[i]) > -1) { hit = true; } }
  if (!hit) return;
  var st = document.createElement('style');
  st.textContent = '.tj .tj-seasons-title,.tj .tj-seasons,.tj .tj-lawntypes{display:none !important}';
  (document.head || document.documentElement).appendChild(st);
})();

/* =====================================================================
   LAWNHUB - BUSH pages are about the GARDEN, not the lawn (Dylan).
   On the BUSH fertiliser + Bush Gone Wild pack pages: hide the lawn-type
   chips (irrelevant to garden beds) and swap remaining lawn wording to
   garden in the story section. ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  var path = location.pathname.toLowerCase();
  if (path.indexOf('/products/lawnhub-bush-garden-fertiliser') === -1 && path.indexOf('/products/lawnhub-bush-gone-wild-pack') === -1) return;
  var st = document.createElement('style');
  st.textContent = '.tj .tj-lawntypes{display:none !important}';
  (document.head || document.documentElement).appendChild(st);
  var SWAPS = [
    ['your lawn', 'your garden'],
    ['the lawn', 'the garden'],
    ['all lawn varieties', 'all common gardens'],
    ['lawn types', 'garden types'],
    ['Lawn care', 'Garden care'],
    ['lawn care', 'garden care']
  ];
  function run() {
    var tj = document.querySelector('.tj');
    if (!tj) return;
    var w = document.createTreeWalker(tj, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var p = n.parentNode;
      if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') continue;
      var t = n.nodeValue;
      var out = t;
      for (var i = 0; i < SWAPS.length; i++) { if (out.indexOf(SWAPS[i][0]) > -1) out = out.split(SWAPS[i][0]).join(SWAPS[i][1]); }
      if (out !== t) n.nodeValue = out;
    }
  }
  function init() {
    run();
    var tj = document.querySelector('.tj');
    if (tj) new MutationObserver(run).observe(tj, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Liquids need a sprayer (22 Jul, Dylan; rev 22 Jul).
   Three note variants:
   - STD single liquids (Wet, Money Shot, Threeway, NSFW): the standard
     applied-with-a-pressure-sprayer note plus Shop Solo link.
   - OPT single liquids (Roots N Shoots, Escort) - can be applied with a
     watering can too, so the note is just the shop link.
   - LIQUID PACKS (any pack that contains at least one sprayer-applied
     liquid): some-products-in-this-pack-need-a-sprayer note plus link.
   Sprayer link points at Solo-only view. Cart drawer shows one nudge if
   the cart has any qualifying product and no sprayer/spreader/nozzle.
   ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';

  var LIQUIDS_STD = [
    'lawnhub-moist-1l-soil-wetting-agent',
    'lawnhub-money-shot-1l-lawn-fertiliser',
    'lawnhub-threeway-8-10-5-trace-elements',
    'nsfw-500ml-broadleaf-herbicide'
  ];
  var LIQUIDS_OPT = [
    'lawnhub-roots-n-shoots-1l-lawn-fertiliser',
    'escort-soil-conditioner-1l'
  ];
  var LIQUID_PACKS = [
    'liquid-grow-and-blow-pack',
    'spray-pack-for-pressure-sprayers',
    'ultimate-spray-pack-for-pressure-sprayers',
    'grow-and-blow-pack',
    'essentials-pack',
    'lawnhub-amateur-pack',
    'golf-course-pack',
    'lawnhub-dry-college-party-pack',
    'half-load-pack',
    'lawnhub-wet-college-party-pack',
    'ultimate-renovation-pack',
    'lawnhub-party-pack-plus',
    'lawnhub-full-load-pack',
    'small-college-party-pack',
    'spread-ya-seed-pack'
  ];
  var SPRAYERS_URL = '/collections/garden-sprayers?filter.p.vendor=Solo';

  function classify(h) {
    if (LIQUIDS_STD.indexOf(h) > -1) return 'std';
    if (LIQUIDS_OPT.indexOf(h) > -1) return 'opt';
    if (LIQUID_PACKS.indexOf(h) > -1) return 'pack';
    return '';
  }
  function isQualifying(h) { return classify(h) !== ''; }
  function isSprayerHandle(h) {
    return h.indexOf('sprayer') > -1 || h.indexOf('solo-') === 0 || h.indexOf('spray-boom') > -1 || h.indexOf('spray-wand') > -1 || h.indexOf('nozzle') > -1 || h.indexOf('spreader') > -1;
  }

  var DROP_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#4E8F26" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/></svg>';

  function injectCss() {
    if (document.getElementById('lh-sprayer-css')) return;
    var st = document.createElement('style');
    st.id = 'lh-sprayer-css';
    st.textContent =
      '.lh-sprayer-note{display:flex;align-items:center;gap:10px;background:#f2f8ec;border:1.5px solid #cde3b8;border-radius:12px;padding:12px 16px;margin:14px 0;max-width:430px;font-size:14px;font-weight:600;color:#2f3b26;line-height:1.45}' +
      '.lh-sprayer-note svg{flex:0 0 auto}' +
      '.lh-sprayer-note a{color:#4E8F26;font-weight:800;text-decoration:underline;white-space:nowrap}' +
      '.lh-sprayer-cart{display:flex;align-items:center;gap:10px;background:#f2f8ec;border:1.5px solid #cde3b8;border-radius:12px;padding:12px 14px;margin:12px 16px;font-size:13.5px;font-weight:600;color:#2f3b26;line-height:1.4}' +
      '.lh-sprayer-cart svg{flex:0 0 auto}' +
      '.lh-sprayer-cart a{color:#4E8F26;font-weight:800;text-decoration:underline;white-space:nowrap}';
    document.head.appendChild(st);
  }

  function pdpNote() {
    var path = location.pathname.toLowerCase();
    if (path.indexOf('/products/') === -1) return;
    var handle = path.split('/products/')[1].split('?')[0].split('/')[0];
    var kind = classify(handle);
    if (!kind) return;
    if (document.getElementById('lh-sprayer-note')) return;
    var anchor = document.querySelector('.tj #tj-form') || document.querySelector('.tj .tj-fit') || document.querySelector('.tj .tj-price');
    if (!anchor) return;
    var lead = '';
    if (kind === 'std') lead = 'Applied with a pressure sprayer. ';
    else if (kind === 'pack') lead = 'Some products in this pack are applied with a pressure sprayer. ';
    var el = document.createElement('div');
    el.id = 'lh-sprayer-note';
    el.className = 'lh-sprayer-note';
    el.innerHTML = DROP_SVG + '<span>' + lead + '<a href="' + SPRAYERS_URL + '">Need a sprayer? Shop Solo &rarr;</a></span>';
    anchor.insertAdjacentElement('afterend', el);
  }

  var checking = false;
  function cartNudge() {
    if (checking) return;
    checking = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        checking = false;
        var items = cart.items || [];
        var hasQualifying = false, hasSprayer = false;
        items.forEach(function (it) {
          var h = it.handle || '';
          if (isQualifying(h)) hasQualifying = true;
          if (isSprayerHandle(h)) hasSprayer = true;
        });
        var existing = document.getElementById('lh-sprayer-cart');
        if (!items.length || !hasQualifying || hasSprayer) { if (existing) existing.remove(); return; }
        if (existing) return;
        var mc = document.getElementById('mini-cart');
        if (!mc) return;
        var host = mc.querySelector('.mini-cart__recommendations') || mc.querySelector('form');
        if (!host) return;
        var el = document.createElement('div');
        el.id = 'lh-sprayer-cart';
        el.className = 'lh-sprayer-cart';
        el.innerHTML = DROP_SVG + '<span>Some of your products need a pressure sprayer to apply. <a href="' + SPRAYERS_URL + '">Shop Solo sprayers &rarr;</a></span>';
        host.insertAdjacentElement('beforebegin', el);
      })
      .catch(function () { checking = false; });
  }

  var t;
  function debounced() { clearTimeout(t); t = setTimeout(cartNudge, 350); }

  function init() {
    injectCss();
    pdpNote();
    ['cart:updated', 'cart:refresh', 'variant:added'].forEach(function (ev) {
      document.addEventListener(ev, debounced);
      document.documentElement.addEventListener(ev, debounced);
    });
    debounced();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Armyworm Battle Pack step-circle fix (22 Jul, Dylan).
   Step 1 (Strike) applies TWO products on the SAME day - Acelepryn GR
   and BBW - but the circle only shows one colour (BBW blue). Match the
   two-product split used on other packs: a 50/50 blue (BBW) + white
   (Acelepryn GR granule) circle, with a hairline ring so the white half
   stays visible on the light card. Step colours live in the large
   product-story.liquid (owned elsewhere) and are not metafield-driven,
   so this is a page-scoped override. ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  if (location.pathname.toLowerCase().indexOf('/products/armyworm-battle-pack') === -1) return;
  var SPLIT = 'linear-gradient(135deg,#80CAE9 50%,#ffffff 50%)';
  var tries = 0;
  function apply() {
    var num1 = document.querySelector('.tj .tj-step .tj-step__num');
    if (!num1) { if (tries++ < 20) setTimeout(apply, 150); return; }
    num1.style.background = SPLIT;
    num1.style.color = '#16210B';
    num1.style.boxShadow = 'inset 0 0 0 1.5px rgba(20,22,19,.18)';
  }
  function init() {
    apply();
    var tj = document.querySelector('.tj');
    if (tj) new MutationObserver(apply).observe(tj, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Packs say "pack", not "product" (Dylan). On a pack page the
   product-story section renders a .tj-packlist (the what's-in-the-pack
   list). There the seasons heading reads "This product is suitable...";
   swap product->pack in that heading. Single products are untouched.
   ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  function run() {
    if (!document.querySelector('.tj .tj-packlist')) return;
    var h = document.querySelector('.tj .tj-seasons-title');
    if (!h) return;
    var w = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue;
      if (t.indexOf('This product') > -1) n.nodeValue = t.split('This product').join('This pack');
      else if (t.indexOf('this product') > -1) n.nodeValue = t.split('this product').join('this pack');
    }
  }
  function init() {
    run();
    var tj = document.querySelector('.tj');
    if (tj) new MutationObserver(run).observe(tj, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Pack step-circle colour splits (Dylan). Where a step applies
   more than one product, split the circle between those products' colours
   (matches the armyworm treatment). Step colours live in the large
   product-story.liquid (owned elsewhere), so this is a page-scoped override
   keyed by product handle. ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  var MAP = {
    'half-load-pack': ['linear-gradient(135deg,#387ABE 50%,#ffffff 50%)', '', ''],
    'lawnhub-full-load-pack': ['linear-gradient(135deg,#387ABE 0 33.33%,#77C043 33.33% 66.66%,#ffffff 66.66% 100%)', '', ''],
    'spread-ya-seed-pack': ['linear-gradient(135deg,#77C043 50%,#BF68AA 50%)', 'linear-gradient(135deg,#80CAE9 50%,#ffffff 50%)', '']
  };
  var path = location.pathname.toLowerCase();
  var handle = '';
  for (var k in MAP) { if (path.indexOf('/products/' + k) > -1) handle = k; }
  if (!handle) return;
  var bgs = MAP[handle];
  var tries = 0;
  function apply() {
    var nums = document.querySelectorAll('.tj .tj-step__num');
    if (!nums.length) { if (tries++ < 20) setTimeout(apply, 150); return; }
    [].slice.call(nums).forEach(function (n, i) {
      if (bgs[i]) {
        n.style.background = bgs[i];
        n.style.color = '#16210B';
        n.style.boxShadow = 'inset 0 0 0 1.5px rgba(20,22,19,.18)';
      }
    });
  }
  function init() {
    apply();
    var tj = document.querySelector('.tj');
    if (tj) new MutationObserver(apply).observe(tj, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Klaviyo popup restyle (Dylan 23 Jul). The signup popup ships
   with a 16x16px close button (unusable on phones), a 23px-tall submit
   and generic styling. Klaviyo's classes are dynamic (go####), so style
   via stable hooks: .klaviyo-close-form, input types and button text.
   Inline styles win over Klaviyo's injected CSS. 16px+ inputs also stop
   iOS auto-zooming the form. ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  function styleForm(form) {
    if (form.dataset.lhStyled) return;
    form.dataset.lhStyled = '1';
    var ff = '"Archivo",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif';
    // Round the dialog card (nearest ancestor that paints the white card)
    var card = form.parentElement;
    for (var i = 0; i < 4 && card; i++) {
      var bg = getComputedStyle(card).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') break;
      card = card.parentElement;
    }
    if (card) { card.style.borderRadius = '18px'; card.style.overflow = 'hidden'; }
    // Close button: 44px circle, always tappable
    var close = document.querySelector('button.klaviyo-close-form');
    if (close) {
      close.style.cssText += ';width:44px !important;height:44px !important;min-width:44px;min-height:44px;top:10px;right:10px;background:#141613;border-radius:99px;display:flex;align-items:center;justify-content:center;opacity:.92;z-index:5;padding:10px;box-sizing:border-box';
      var svg = close.querySelector('svg');
      if (svg) { svg.style.cssText += ';width:18px;height:18px;stroke:#ffffff;fill:#ffffff;color:#ffffff'; svg.setAttribute('width', '18'); svg.setAttribute('height', '18'); }
      [].slice.call(close.querySelectorAll('path')).forEach(function (p) { p.style.fill = '#ffffff'; p.style.stroke = '#ffffff'; });
    }
    // Inputs: site-style pills, 16px font (prevents iOS zoom)
    [].slice.call(form.querySelectorAll('input[type="email"], input[type="tel"], input[type="text"]')).forEach(function (inp) {
      inp.style.cssText += ';font-size:16px !important;padding:13px 14px;border-radius:12px;border:1.5px solid #d9dcd2;font-family:' + ff;
    });
    // Buttons: find by text
    [].slice.call(form.querySelectorAll('button')).forEach(function (b) {
      var t = (b.textContent || '').trim().toLowerCase();
      if (t.indexOf('sign up') > -1) {
        b.style.cssText += ';background:#77C043 !important;color:#16210B !important;border:0;border-radius:12px;min-height:50px;font-weight:800;font-size:16px;letter-spacing:.4px;font-family:' + ff;
      } else if (t.indexOf('no thanks') > -1) {
        b.style.cssText += ';min-height:40px;font-size:14px;color:#5b5f56 !important;text-decoration:underline;font-family:' + ff;
      }
    });
  }
  function scan() {
    var form = document.querySelector('form.klaviyo-form');
    if (form) styleForm(form);
  }
  var obs = new MutationObserver(scan);
  function init() { scan(); obs.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Remove the per-product FAQ accordion (Dylan 23 Jul). Hide only
   the FAQ heading + accordion items inside .tj-faqs. Do NOT hide the whole
   section: it also holds the .tj-docbar (styled SDS / Label download
   buttons) and the .tj-contact line, which must stay visible (hiding the
   whole section removed the SDS download on NSFW). ASCII, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  function prune() {
    var sec = document.querySelector('.tj .tj-faqs, section.tj-faqs, .tj-faqs');
    if (!sec) return;
    sec.style.display = '';
    var head = sec.querySelector('.tj-head');
    if (head) head.style.display = 'none';
    [].slice.call(sec.querySelectorAll('details.tj-faq')).forEach(function (d) {
      d.style.display = 'none';
    });
  }
  function init() {
    prune();
    var tj = document.querySelector('.tj');
    if (tj) new MutationObserver(prune).observe(tj, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - Per-page cosmetic overrides where a false boolean metafield
   cannot turn a file default off (this theme treats a false boolean as
   unset and falls back to the file). Escort: hide the results timeline.
   Spread Ya Seed: grey the winter tile (late summer to autumn only).
   ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  var path = location.pathname.toLowerCase();
  if (path.indexOf('/products/escort-soil-conditioner-1l') > -1) {
    var st = document.createElement('style');
    st.textContent = '.tj .tj-timeline{display:none !important}';
    (document.head || document.documentElement).appendChild(st);
  }
  if (path.indexOf('/products/spread-ya-seed-pack') > -1) {
    var run = function () {
      var w = document.querySelector('.tj .tj-season[data-season="winter"]');
      if (w) w.classList.add('off');
      // Pack now ships PRIMO HG, not Astro 120 (pack tiles are not metafield-driven)
      [].slice.call(document.querySelectorAll('.tj a[href*="astro-120"]')).forEach(function (a) {
        a.setAttribute('href', '/products/primo-hg-turf-growth-regulator-500ml');
      });
      var tw = document.createTreeWalker(document.querySelector('.tj') || document.body, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = tw.nextNode())) {
        var t = n.nodeValue;
        var out = t.split('ASTRO 120').join('PRIMO HG').split('Astro 120').join('Primo HG').split('1L of Primo HG').join('500mL of Primo HG');
        if (out !== t) n.nodeValue = out;
      }
    };
    var initSeed = function () {
      run();
      var tj = document.querySelector('.tj');
      if (tj) new MutationObserver(run).observe(tj, { childList: true, subtree: true });
    };
    if (document.readyState !== 'loading') initSeed();
    else document.addEventListener('DOMContentLoaded', initSeed);
  }
})();

/* =====================================================================
   LAWNHUB - clean hero intro truncation, site-wide (Dylan 23 Jul).
   The .tj template truncates product.description to 240 chars for the
   blurb under the product title (.tj-hero__intro), cutting mid-word
   with an ellipsis. Rebuild the blurb from the full details text and
   end it at the last complete sentence instead. Product Details keeps
   the full description. ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  function norm(s) {
    var out = '';
    for (var i = 0; i < s.length; i++) {
      out += s.charCodeAt(i) < 33 ? ' ' : s.charAt(i);
    }
    while (out.indexOf('  ') > -1) out = out.split('  ').join(' ');
    return out.trim();
  }
  function fix() {
    var intro = document.querySelector('.tj-hero__intro');
    var body = document.querySelector('.tj-details__body');
    if (!intro || !body) return;
    if (intro.getAttribute('data-lh-trim') === '1') return;
    var shown = norm(intro.textContent || '');
    if (shown.slice(-3) !== '...') {
      intro.setAttribute('data-lh-trim', '1');
      return;
    }
    var full = norm(body.textContent || '');
    if (full.length < 40) return;
    var cut = full.slice(0, 240);
    var best = -1;
    for (var i = cut.length - 1; i >= 60; i--) {
      var ch = cut.charAt(i);
      if (ch === '.' || ch === '!' || ch === '?') {
        var nxt = i + 1 < full.length ? full.charAt(i + 1) : ' ';
        if (nxt === ' ') { best = i; break; }
      }
    }
    var out;
    if (best > -1) {
      out = cut.slice(0, best + 1);
    } else {
      var sp = cut.lastIndexOf(' ');
      out = (sp > 60 ? cut.slice(0, sp) : cut) + '...';
    }
    intro.textContent = out;
    intro.setAttribute('data-lh-trim', '1');
  }
  function init() {
    fix();
    var tj = document.querySelector('.tj');
    if (tj) new MutationObserver(fix).observe(tj, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* =====================================================================
   LAWNHUB - product Label download buttons (Dylan 23 Jul). Registered
   label PDFs (latest versions, from the Google Drive Lawnhub Labels
   folder) are now hosted on the Shopify CDN. Add a "Download Product
   Label" button styled EXACTLY like the theme's SDS button (a.tj-docbtn
   inside .tj-docbar in the .tj-faqs section), creating the docbar when a
   product has no SDS. ASCII only, no backslashes.
   ===================================================================== */
(function () {
  'use strict';
  var CDN = 'https://cdn.shopify.com/s/files/1/0036/9603/3903/files/';
  var LABELS = {
    'lawnhub-moist-1l-soil-wetting-agent': 'Lawnhub_WET_Label_2026.pdf?v=1784787896',
    'escort-soil-conditioner-1l': 'Lawnhub_ESCORT_Label.pdf?v=1784786166',
    'lawnhub-threeway-8-10-5-trace-elements': 'Lawnhub_THREEWAY_Label.pdf?v=1784786165',
    'lawnhub-roots-n-shoots-1l-lawn-fertiliser': 'Lawnhub_ROOTS_N_SHOOTS_Label_2026.pdf?v=1784787896',
    'lawnhub-money-shot-1l-lawn-fertiliser': 'Lawnhub_MONEY_SHOT_Label.pdf?v=1784786165',
    'lawnhub-trojan-lawn-fertiliser-25-0-10-3-fe-5kg': 'Lawnhub_TROJAN_5kg_Label.pdf?v=1784786165',
    'lawnhub-trojan-25-0-10-2-5-10kg-lawn-fertiliser': 'Lawnhub_TROJAN_10kg_Label.pdf?v=1784786165',
    'lawnhub-premature-20-0-16-6-5kg-winter-lawn-fertiliser': 'Lawnhub_PREMATURE_Label.pdf?v=1784786165',
    'lawnhub-got-laid-starter-fertiliser-19-11-10-5kg': 'Lawnhub_GOT_LAID_Label.pdf?v=1784786165',
    'lawnhub-bush-garden-fertiliser-12-3-7-biology-5kg': 'Lawnhub_BUSH_Label.pdf?v=1784786166',
    'lawnhub-mini-pill-slow-release-fertiliser': 'Lawnhub_MINI_PILL_Label.pdf?v=1784786166',
    'lawnhub-bbw-granular-wetting-agent-3kg': 'Lawnhub_BBW_Label.pdf?v=1784786165',
    'lawnhub-seed-100-ryegrass': 'Lawnhub_SEED_Label.pdf?v=1784786166',
    'nsfw-500ml-broadleaf-herbicide': 'NSFW_Label_1.pdf?v=1784786165'
  };
  var parts = (location.pathname || '').split('/');
  var idx = parts.indexOf('products');
  var handle = idx > -1 ? parts[idx + 1] : '';
  var file = LABELS[handle];
  if (!file) return;
  var SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2.5H6.5A1.5 1.5 0 0 0 5 4v16a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 19 20V7.5z"></path><path d="M14 2.5V7.5H19"></path><path d="M12 11v6M12 17l-2.5-2.5M12 17l2.5-2.5"></path></svg>';
  function add() {
    var sec = document.querySelector('.tj-faqs');
    if (!sec || sec.querySelector('a[data-lh-labelbtn]')) return;
    var bar = sec.querySelector('.tj-docbar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'tj-docbar';
      var contact = sec.querySelector('.tj-contact');
      if (contact) sec.insertBefore(bar, contact);
      else sec.appendChild(bar);
    }
    var a = document.createElement('a');
    a.className = 'tj-docbtn';
    a.href = CDN + file;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('data-lh-labelbtn', '1');
    a.innerHTML = SVG + '<span>Download Product Label<small>PDF &#183; full directions for use</small></span>';
    bar.appendChild(a);
    var list = [].slice.call(bar.querySelectorAll('a.tj-docbtn'));
    list.forEach(function (b) {
      b.style.width = '100%';
      b.style.maxWidth = '480px';
      b.style.boxSizing = 'border-box';
      b.style.removeProperty('min-height');
    });
    var max = 0;
    list.forEach(function (b) { if (b.offsetHeight > max) max = b.offsetHeight; });
    list.forEach(function (b) { b.style.setProperty('min-height', max + 'px', 'important'); });
  }
  function init() {
    add();
    var tj = document.querySelector('.tj');
    if (tj) new MutationObserver(add).observe(tj, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
